import React, { useEffect, useState, useRef } from "react";
import { api } from "../lib/api";
import { Coins } from "lucide-react";
import { toast } from "sonner";

export default function AdSlot() {
  const [ad, setAd] = useState(null);
  const [credited, setCredited] = useState(null);
  const loggedRef = useRef(false);

  useEffect(() => { api.get("/ads/next").then((r) => setAd(r.data.ad)).catch(() => {}); }, []);

  useEffect(() => {
    if (!ad || loggedRef.current) return;
    if (!localStorage.getItem("pd_token")) return; // Only logged-in users earn
    loggedRef.current = true;
    const timer = setTimeout(() => {
      api.post("/ads/view", { ad_id: ad.id }).then((r) => {
        if (r.data.credited) {
          setCredited(r.data);
          toast.success(`+$${r.data.earned.toFixed(4)} earned for viewing an ad 🪙`);
        }
      }).catch(() => {});
    }, 3000);
    return () => clearTimeout(timer);
  }, [ad]);

  const click = async () => {
    try { await api.post(`/ads/click/${ad.id}`); } catch (_) {}
  };

  if (!ad) return null;

  return (
    <section data-testid="ad-slot" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
      <div className="flex items-center justify-between mb-3">
        <span className="overline text-[#8C6D3B]">Sponsored · view-to-earn</span>
        {credited && (
          <span className="inline-flex items-center gap-1 text-xs text-[#E65100] font-mono">
            <Coins className="w-3.5 h-3.5" /> +${credited.earned.toFixed(4)} added to your wallet
          </span>
        )}
      </div>
      <a href={ad.click_url} target="_blank" rel="noopener sponsored" onClick={click}
        data-testid={`ad-${ad.id}`}
        className="group grid md:grid-cols-5 gap-6 bg-[#FFFDF9] sacred-border rounded-3xl overflow-hidden transition-sacred gold-glow">
        <div className="md:col-span-2 h-56 md:h-auto overflow-hidden bg-[#F3E5AB]/30">
          {ad.image_url && <img src={ad.image_url} alt={ad.headline} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
        </div>
        <div className="md:col-span-3 p-7 flex flex-col justify-center">
          <div className="text-xs text-[#8C6D3B] font-mono uppercase tracking-wider">{ad.advertiser_name}</div>
          <h3 className="font-serif text-2xl text-[#4A0E17] mt-2 leading-tight">{ad.headline}</h3>
          {ad.body && <p className="text-[#63534E] mt-3 leading-relaxed">{ad.body}</p>}
          <span className="inline-block mt-5 text-sm font-semibold text-[#E65100]">Learn more →</span>
        </div>
      </a>
    </section>
  );
}
